// show list client
export const GET_LIST_CLIENT_MANAGEMENT = "GET_LIST_CLIENT_MANAGEMENT"
export const TAIKHOAN_CLIENT_MANAGEMENT = "TAIKHOAN_CLIENT_MANAGEMENT"
// edit list client
export const PAGE_EDIT_CLIENT = "PAGE_EDIT_CLIENT"
export const GET_INFO_CLIENT = "GET_INFO_CLIENT"
// update
export const UPDATE_LIST_CLIENT_MANAGEMENT = "UPDATE_LIST_CLIENT_MANAGEMENT"
// add
export const ADD_CLIENT_MANAGEMENT = "ADD_CLIENT_MANAGEMENT"


// not use
export const MESAGE_DELETE_CLIENT_MANAGEMENT = "MESAGE_DELETE_CLIENT_MANAGEMENT"
export const DELETE_LIST_CLIENT_MANAGEMENT = "DELETE_LIST_CLIENT_MANAGEMENT"